import script from "./Ruler.vue?vue&type=script&lang=ts&setup=true"
export * from "./Ruler.vue?vue&type=script&lang=ts&setup=true"

import "./Ruler.vue?vue&type=style&index=0&id=0f6bb088&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6bb088"]])

export default __exports__